import { css } from 'styled-components';

export const ActionWrapperBackgroundMixin = (isTopHeader?: boolean) => css`
	background: ${({ theme }) => {
		const isNewDesign = theme.variant === 'v26';
		const v26GradientTop = 'linear-gradient(98deg, #22293d 0%, #11192e 100%)';

		if (isTopHeader) {
			return isNewDesign ? v26GradientTop : 'rgba(223, 228, 232, 0.8)';
		}

		return isNewDesign ? v26GradientTop : 'linear-gradient(rgba(223, 228, 232, 0.8) 20%, rgba(223, 228, 232, 1) 60%)';
	}};
	backdrop-filter: ${({ theme }) => {
		if (theme.variant !== 'v26') return 'none';
		return isTopHeader ? 'blur(4px)' : 'blur(8px)';
	}};
`;
